import { render, staticRenderFns } from "./IntelligentPhysical.vue?vue&type=template&id=391f29de&"
import script from "./IntelligentPhysical.vue?vue&type=script&lang=js&"
export * from "./IntelligentPhysical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports